import React, { useEffect, useState } from "react";
// eslint-disable-next-line
import { Route, Redirect, useLocation } from "react-router-dom";
import { useSnackbar } from "notistack";
import PropTypes from "prop-types";

import { useAuth } from "../auth/AuthProvider";
import { useUser } from "../auth/UserProvider";
import LoadingComponent from "./LoadingComponent";

const PrivateRoute = ({ component: Component, forOwner = false, ...rest }) => {
  const { isInitialized, isAuthenticated, loginRedirect } = useAuth();
  const { isAdmin, isOwner: validOwner } = useUser();
  const { enqueueSnackbar } = useSnackbar();

  const isOwner = forOwner && validOwner;
  const isManagementHR = JSON.parse(localStorage.getItem("isManagementHR"));
  const { pathname } = useLocation();

  const [hrPathName, setHrPathName] = useState(null);

  useEffect(() => {
    if (pathname.includes("/Administration/Hr")) {
      setHrPathName(true);
    } else {
      setHrPathName(false);
    }
  }, [pathname]);

  useEffect(() => {
    if (isInitialized && !isAuthenticated) {
      loginRedirect({
        redirectPath: `${pathname}${window.location.search}${window.location.hash}`,
      });
    }
  }, [isAuthenticated, isInitialized, loginRedirect, pathname]);

  if (!isInitialized || !isAuthenticated) {
    return <LoadingComponent loading />;
  }

  return (
    <>
      {hrPathName !== null && (
        <Route
          {...rest}
          render={(props) =>
            isAdmin || isOwner || (isManagementHR && hrPathName) ? (
              <Component {...props} />
            ) : (
              <>
                {enqueueSnackbar("Sorry, you don't have access to this Page.", {
                  variant: "error",
                })}
                <Redirect
                  to={{
                    pathname: "/",
                  }}
                />
              </>
            )
          }
        />
      )}
    </>
  );
};

PrivateRoute.propTypes = {
  component: PropTypes.func,
  forOwner: PropTypes.bool,
};

export default PrivateRoute;
